const langtrans={
      ddjxjy:["大救星救援平台","en_translated"],
      ajjjk:["案件监控","Case monitoring"],
      ajgl:["案件管理","Case management"],
      jtbtzz:["简体中文","Symplified Chinese"],
      jgsz:["机构设置","Organization"],
      lsaj:["历史案件","Completed Cases"],
      ajtj:["案件统计","Case statistics"],
	  whzyh:["维护子用户","Preserve Subuser"],
	  dhwh:["电话维护","Phone Maintenance"],
      cwgl:["财务管理","Financial Management"],
      swktt:["尚未开通","Not avaliable"],
      tcajkz:["退出案件控制台","Log out "],
      jjgjg:["监管机构","en_translated"],
      zzzhzz:["指挥中心","en_translated"],
      zxcg:["注销成功！","Log out successfully"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/components/header/index.vue.trans.js